import { put } from '@client/lib/request';

export const subscribeToNewsletter = () => put('/mylounge-api/newsletter/subscribe');
